import { useEffect, useState } from "react";
import {
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  OutlinedInput,
} from "@mui/material";
import validarCPF from "../../../utils/validar-cpf";
import cpfMask from "../../../utils/cpf-mask";
import { getZones } from "../../../services/zone-service";
import { getPermissions } from "../../../services/permission-service";
import { getCompanies } from "../../../services/company-service";
import { createUser } from "../../../services/user-service";
import SelectInput from "../../../components/Select/SelectInput";

export default function RegisterUser() {
  const [errorCpf, setErrorCpf] = useState({ status: false, message: "" });
  const [errorEmail, setErrorEmail] = useState({ status: false, message: "" });
  const [selectedPermission, setSelectedPermission] = useState([]);
  const [selectedZone, setSelectedZone] = useState([]);
  const [selectedCompanies, setSelectedCompanies] = useState([]);
  const [selectList, setSelectList] = useState({ zones: [], permissions: [] });
  const [companies, setCompanies] = useState([]);
  const [formValues, setFormValues] = useState({
    name: "",
    cpf: "",
    password: "",
    email: "",
    comissao: "",
    k: "",
    k_arla: "",
  });

  const accessToken = localStorage.getItem("token");
  const role = JSON.parse(localStorage.getItem("role"));
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const domains = [
    "riopretopetroleo",
    "unipetrobr",
    "gasodiesel",
    "unipetrominas",
  ];

  function handleCpf(e) {
    if (!validarCPF(e.target.value)) {
      return setErrorCpf({ message: "Cpf inválido", status: true });
    }
    setErrorCpf({ message: "", status: false });
  }

  function handleChanges(e) {
    setFormValues((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  }

  function handleChangeCpf(e) {
    setFormValues((prevState) => ({
      ...prevState,
      [e.target.name]: cpfMask(e.target.value),
    }));
  }

  function handleEmail(e) {
    let hasDomain = false;

    if (!e.target.value.includes("@")) {
      return setErrorEmail({
        message: "Favor inserir email correto.",
        status: true,
      });
    }

    const dividedEmail = e.target.value.split("@");

    // eslint-disable-next-line array-callback-return
    domains.map((domain) => {
      if (dividedEmail[1].includes(domain)) hasDomain = true;
    });

    if (hasDomain === false) {
      return setErrorEmail({
        message: "Domínio de email não permitido.",
        status: true,
      });
    }

    setErrorEmail({ message: "", status: false });
  }

  async function handleSubmit(e) {
    e.preventDefault();

    if (
      !formValues.name ||
      !formValues.password ||
      !formValues.cpf ||
      !selectedZone.length === 0 ||
      !selectedPermission.length === 0
    ) {
      return alert("Favor conferir os dados do formulário.");
    }

    const data = {
      ...formValues,
      permission_id: selectedPermission,
      zones: selectedZone,
      company_id: selectedCompanies[0],
      comissao_especial_zona: 0.54,
      comissao_especial_zona_k: 0.53,
    };

    console.log(data);

    try {
      await createUser(accessToken, data);

      alert("Usuário cadastrado com sucesso.");
    } catch (error) {
      alert("Algo deu errado, tente novamente.");
    }
  }

  useEffect(() => {
    async function getSelectValues() {
      const zones = await getZones(accessToken);
      const permissions = await getPermissions(accessToken);
      const companies = await getCompanies(accessToken);

      if (role === 4) {
        return setSelectList({
          permissions: [
            { id: 2, name: "Supervisor" },
            { id: 3, name: "Vendedor" },
          ],
          zones,
        });
      }
      setSelectList({ permissions, zones });
      setCompanies(companies);
    }
    getSelectValues();
  }, [accessToken, role]);

  return (
    <>
      <form className="form-container">
        <h1>Cadastro de Usuários</h1>
        <TextField
          label="Nome"
          name="name"
          onChange={handleChanges}
          inputProps={{
            autoComplete: "off",
          }}
        />
        <TextField
          error={errorCpf.status}
          name="cpf"
          label="Cpf"
          value={formValues.cpf}
          onChange={handleChangeCpf}
          onBlur={handleCpf}
          helperText={errorCpf.message}
          inputProps={{
            autoComplete: "off",
          }}
        />
        <TextField
          label="Email"
          name="email"
          error={errorEmail.status}
          onChange={handleChanges}
          type="email"
          onBlur={handleEmail}
          helperText={errorEmail.message}
          inputProps={{
            autoComplete: "off",
          }}
        />
        <TextField
          label="Senha"
          name="password"
          onChange={handleChanges}
          type="password"
          autoComplete="off"
        />

        <SelectInput
          value={selectedPermission}
          name="Permissão"
          setValue={setSelectedPermission}
          selectValues={selectList.permissions}
        />

        <FormControl>
          <InputLabel id="demo-multiple-checkboxx-label">Zonas</InputLabel>
          <Select
            labelId="demo-multiple-checkboxx-label"
            id="demo-multiple-checkbox"
            multiple
            value={selectedZone}
            onChange={(e) => setSelectedZone(e.target.value)}
            input={<OutlinedInput label="Zonas" />}
            renderValue={(selected) => selected.join(", ")}
            MenuProps={MenuProps}
          >
            {selectList.zones?.map((item) => (
              <MenuItem key={item.name} value={item.id}>
                <Checkbox checked={selectedZone.indexOf(item.id) > -1} />
                <ListItemText primary={item.name} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl>
          <InputLabel id="demo-multiple-checkboxx-label">Companhias</InputLabel>
          <Select
            labelId="demo-multiple-checkboxx-label"
            id="demo-multiple-checkbox"
            multiple
            value={selectedCompanies}
            onChange={(e) => setSelectedCompanies(e.target.value)}
            input={<OutlinedInput label="Companhias" />}
            renderValue={(selected) => selected.join(", ")}
            MenuProps={MenuProps}
          >
            {companies.map((item) => (
              <MenuItem key={item.name} value={item.id}>
                <Checkbox checked={selectedCompanies.indexOf(item.id) > -1} />
                <ListItemText primary={item.name} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          label="Comissão em %"
          name="comission"
          onChange={handleChanges}
          autoComplete="off"
        />

        <div className="k-inputs">
          <TextField
            label="K"
            name="k"
            onChange={handleChanges}
            autoComplete="off"
          />

          <TextField
            label="K Arla"
            name="k_arla"
            onChange={handleChanges}
            autoComplete="off"
          />
        </div>

        <Button type="submit" onClick={handleSubmit} variant="contained">
          Cadastrar
        </Button>
      </form>
    </>
  );
}
